export const V2_MOTION = {
  ease: {
    /** Curva estándar sin rebote, similar a Material ease-out. */
    standard: "cubic-bezier(0.4, 0, 0.2, 1)",
    /** Curva líquida con rebote perceptible para morphs grandes. */
    liquid: "cubic-bezier(0.34, 1.2, 0.64, 1)",
    /** Rebote fuerte al asentar (modales que cambian de alto). */
    liquidBounce: "cubic-bezier(0.28, 1.52, 0.42, 1)",
    /** Curva líquida suave / bajo rebote para CTAs y reveals compactos. */
    liquidSoft: "cubic-bezier(0.34, 1.06, 0.64, 1)",
    /** Reveal premium sin rebote fuerte: crecimiento amplio, estable y elegante. */
    premiumReveal: "cubic-bezier(0.16, 1, 0.3, 1)",
  },
  duration: {
    revealOpen: 380,
    revealClose: 240,
  },
} as const;
